import { earnings, leadFlags } from "./leads";
import { istDateOf } from "./format";
import { LOG_COLUMNS, compareRows, firstDir } from "./logColumns";

const EQUAL_FILTERS = [["status", "status"], ["setter", "setter_id"], ["closer", "closer_id"], ["source", "source"], ["meeting", "meeting_status"]];
const SEARCH_FIELDS = ["name", "company", "email", "phone", "source", "status", "_setterName", "_closerName", "meeting_status", "loss_reason"];

export const toLogRow = (l, repsById, today) => {
  const r = {
    ...l, _setterName: repsById[l.setter_id]?.name, _closerName: repsById[l.closer_id]?.name,
    _flags: leadFlags(l, today), _setterEarn: earnings(l, "setter_pct"), _closerEarn: earnings(l, "closer_pct"), _created: istDateOf(l.date_created),
  };
  r._search = SEARCH_FIELDS.map((k) => r[k]).join(" ").toLowerCase();
  return r;
};

const matchesEquals = (r, f) => EQUAL_FILTERS.every(([fk, rk]) => !f[fk] || r[rk] === f[fk]);
const matchesFlags = (r, f) => (!f.flagged || r._flags.length > 0) && (!f.flagType || r._flags.some((x) => x.key === f.flagType));
const matchesCreated = (r, f) => (!f.from || (r._created && r._created >= f.from)) && (!f.to || (r._created && r._created <= f.to));
const matchesSearch = (r, q) => !q || r._search.includes(q.trim().toLowerCase());

export const matchesFilters = (r, f) => matchesEquals(r, f) && matchesFlags(r, f) && matchesCreated(r, f) && matchesSearch(r, f.q);

export const sortRows = (rows, sort) => rows.sort(compareRows(LOG_COLUMNS.find((c) => c.key === sort.key), sort.dir));

export const nextSort = (s, col) => (s.key === col.key ? { key: col.key, dir: s.dir === "asc" ? "desc" : "asc" } : { key: col.key, dir: firstDir(col) });

export const toExportParams = (f, sort) => ({
  q: f.q, status: f.status, setter_id: f.setter, closer_id: f.closer, source: f.source,
  meeting_status: f.meeting, flagged: f.flagged, flag_type: f.flagType,
  date_from: f.from, date_to: f.to, sort: sort.key, dir: sort.dir,
});
